"use strict";

define('rs/form/formobjects/radio/radio.formobject.view',['rs/form/formobjects/base.formobject.view'], function (BaseFormObjectView) {
  var RadioFormObjectView = BaseFormObjectView.extend({
    templates: {
      'radio.formobject': 'renderContent'
    },
    events: {
      'change >.form-object-contents input': 'handleRadioChange'
    },
    renderFormObject: function renderFormObject() {
      var el = this.getContentElement(),
        delegate = this.getDelegate(),
        templateProperties = this.getDelegate().getTemplateProperties();
      templateProperties.parentIsRequired = this.getDelegate().getParent().getRequired();
      el.html(this.renderContent(templateProperties));
      this.setFormElement(el.find('input'));
      if (delegate.getValue()) {
        RadioFormObjectView.registerRadioChange(this, delegate.getRadioGroup());
      }
    },
    getValue: function getValue() {
      return this.getFormElement().prop('checked');
    },
    handleRadioChange: function handleRadioChange(ev) {
      this.getDelegate().requestValueChange();
      RadioFormObjectView.registerRadioChange(this, this.getDelegate().getRadioGroup());
    }
  }, {
    registry: {},
    registerRadioChange: function registerRadioChange(view, name) {
      var lastView = RadioFormObjectView.registry[name];
      if (lastView && lastView != view) {
        lastView.handleRadioChange();
      }
      RadioFormObjectView.registry[name] = view;
    }
  });
  return RadioFormObjectView;
});

